<template>
  <div class="app-container">
    <el-container v-if="showLayout">
      <el-aside width="200px">
        <el-menu
          router
          :default-active="$route.path"
          class="el-menu-vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="/museums">
            <el-icon><icon-menu /></el-icon>
            <span>博物馆管理</span>
          </el-menu-item>
          <el-menu-item index="/codes">
            <el-icon><document /></el-icon>
            <span>防伪码管理</span>
          </el-menu-item>
          <el-menu-item index="/verify">
            <el-icon><search /></el-icon>
            <span>防伪码验证</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <div class="header-content">
            <h2>博物馆防伪码系统</h2>
            <div class="user-actions">
              <span v-if="authStore.user">{{ authStore.user.name }}</span>
              <el-button
                type="text"
                @click="handleLogout"
              >
                退出
              </el-button>
            </div>
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
        <el-footer>© 2025 博物馆防伪码系统</el-footer>
      </el-container>
    </el-container>
    <router-view v-else />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Menu as IconMenu, Document, Search } from '@element-plus/icons-vue';
import { useAuthStore } from './store/authStore';

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

// 只有在非登录页面时显示布局
const showLayout = computed(() => route.meta.requiresAuth !== false);

// 处理登出
const handleLogout = () => {
  authStore.logout();
  router.push('/login');
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-container {
  height: 100%;
}

.el-header {
  background-color: #409EFF;
  color: white;
  line-height: 60px;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  z-index: 1000;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.el-aside {
  background-color: #545c64;
  color: #333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.el-menu-vertical {
  height: 100%;
  border-right: none;
}

.el-menu-item.is-active {
  background-color: #434a50 !important;
  color: #ffd04b !important;
  border-left: 4px solid #ffd04b;
}

.el-menu-item:hover {
  background-color: #4c535a !important;
}

.el-main {
  background-color: #f5f7fa;
  padding: 20px;
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.el-footer {
  background-color: #f5f7fa;
  color: #606266;
  text-align: center;
  line-height: 60px;
  border-top: 1px solid #e6e6e6;
}
</style>
